import { useSandBox } from '#imports';
import { onBeforeUnmount, onMounted } from 'vue';
import { createLogger } from '~/utils/logger';

const logger = createLogger('window-message');

export const useWindowMessage = ({ onReceiveMessage = () => {} } = {}) => {
    const isSandbox = useSandBox();

    const sendMessage = (type, data = null, force = false) => {
        if (isSandbox && !force) return;

        window.parent.postMessage({ type, data }, '*');
    };

    const receiveMessage = (event) => {
        // Ignore self-messages only when embedded. In a top-level window, local
        // `window.postMessage(...)` is a useful manual testing path.
        if (event.source === window && window.parent !== window) return;

        // Note: event.type is always "message" for MessageEvent
        // The actual message type is in event.data.type
        if (event.data) {
            onReceiveMessage(event);
        } else {
            logger.warn('Window message payload missing', {
                event: 'message.payload_missing',
                source: 'window',
            }, event);
        }
    };

    const addEvents = () => {
        // This is where the page listens for messages from the parent
        window.addEventListener('message', receiveMessage);
    };

    const removeEvents = () => {
        window.removeEventListener('message', receiveMessage);
    };

    onMounted(addEvents);
    onBeforeUnmount(removeEvents);

    return { sendMessage, receiveMessage };
};
